export function getEventLabel(start: moment.Moment, end: moment.Moment, dash?: boolean) {
  const isMultiDay = start.get('date') !== end.get('date')
  const isAllDaySingleDay = start.get('hour') === 0 && end.get('hour') === 0 && end.diff(start, 'days') === 1
  const isAllDayMultiDay = isMultiDay && start.get('hour') === 0 && end.get('hour') === 0

  const postfix = dash ? ' - ' : ''
  const deliniator = dash ? ' to ' : ' - '

  if (isAllDaySingleDay) {
    return `All Day${postfix}`
  }
  if (isAllDayMultiDay) {
    return `${start.format('MMM D')}${deliniator}${end.subtract(1, 'hour').format('MMM D')}${postfix}`
  }
  if (isMultiDay) {
    return `${start.format('MMMM D, h:mma')}${deliniator}${end.format('MMMM D, h:mma')}${postfix}`
  }
  return `${start.format('h:mma')}${deliniator}${end.format('h:mma')}${postfix}`
}
